import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import moment from "moment";

const VendorPaymentView = () => {
  const { id } = useParams();
  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchVendorPayment();
  }, [id]);

  const fetchVendorPayment = async () => {
    try {
      const response = await Http.get(`/accounts/vendor-payments/${id}`);
      setPayment(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching vendor payment:", error);
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    return date ? moment(date).format("YYYY-MM-DD") : "N/A";
  };

  const getPaymentMethodLabel = (method) => {
    const methods = {
      bank_transfer: "Bank Transfer",
      cash: "Cash",
      check: "Check",
      online: "Online Payment"
    };
    return methods[method] || method;
  };

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <p className="mt-2">Loading vendor payment details...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!payment) {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body text-center">
                <p className="text-danger">Vendor payment not found</p>
                <Link to="/accounts/vendor-payments" className="btn btn-primary">
                  Back to List
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Vendor Payment Details</h4>
              <div className="float-right">
                <Link to={`/accounts/vendor-payments/edit/${id}`} className="btn btn-info btn-sm mr-2">
                  <i className="fa fa-edit"></i> Edit
                </Link>
                <Link to="/accounts/vendor-payments" className="btn btn-primary btn-sm">
                  <i className="fa fa-list"></i> Back to List
                </Link>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th style={{ width: "200px" }}>Vendor</th>
                      <td>{payment.vendor ? payment.vendor.name : "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Bank</th>
                      <td>{payment.bank ? payment.bank.bank_name : "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Amount</th>
                      <td>{payment.amount ? `${payment.amount.toFixed(2)}` : "0.00"}</td>
                    </tr>
                    <tr>
                      <th>Payment Date</th>
                      <td>{formatDate(payment.payment_date)}</td>
                    </tr>
                    <tr>
                      <th>Payment Method</th>
                      <td>{getPaymentMethodLabel(payment.payment_method)}</td>
                    </tr>
                    <tr>
                      <th>Reference No</th>
                      <td>{payment.reference_no || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Description</th>
                      <td>{payment.description || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Created At</th>
                      <td>{formatDate(payment.created_at)}</td>
                    </tr>
                    <tr>
                      <th>Updated At</th>
                      <td>{formatDate(payment.updated_at)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorPaymentView;